import React, { useState, useEffect } from "react";
import NavbarItem from "@/components/navbar/navbar-item";
import NavbarDropdown from "@/components/navbar/navbar-dropdown";
import UserProfile from "@/components/navbar/user-profile";
import SearchBarPopup from "@/components/searchbar-popup";
import Image from "next/image";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { useDispatch, useSelector } from "react-redux";

// Icons File Import Below
import {
  SerchIcon,
  UserIcon,
  TrollyIcon,
  HeartIcon,
  BarIcon,
} from "@/components/icons/navbar-icon";
import Cookies from "js-cookie";
import { fetchCartItems } from "@/redux/slices/cartSlice";
import { fetchCategories } from "@/redux/slices/categorySlice";
import { Container, Offcanvas, Navbar, Nav, Button } from "react-bootstrap";
import { CloseIcon } from "../icons/common-button-icon";
import { MinusIcon, PlusIcon } from "../icons/my-cart";
import CommonBtn from "../buttons/CommonBtn";

// import { SerchIcon } from '@/components/icons/navbar-icon/serch-icon';
const cartdata = [
  {
    type: "Lehenga Choli",
    name: "Timepiece Haven",
    image: "assets/images/blog/01.png",
    price: "29.99",
    size: "M",
    color: "Red",
  },
  {
    type: "Lehenga Choli",
    name: "Timepiece Haven",
    image: "assets/images/blog/01.png",
    price: "29.99",
    size: "M",
    color: "Red",
  },
  {
    type: "Lehenga Choli",
    name: "Timepiece Haven",
    image: "assets/images/blog/01.png",
    price: "29.99",
    size: "M",
    color: "Red",
  },
  {
    type: "Lehenga Choli",
    name: "Timepiece Haven",
    image: "assets/images/blog/01.png",
    price: "29.99",
    size: "M",
    color: "Red",
  },
  {
    type: "Lehenga Choli",
    name: "Timepiece Haven",
    image: "assets/images/blog/01.png",
    price: "29.99",
    size: "M",
    color: "Red",
  },
  {
    type: "Lehenga Choli",
    name: "Timepiece Haven",
    image: "assets/images/blog/01.png",
    price: "29.99",
    size: "M",
    color: "Red",
  },
];
export default function Navigation() {
  // Searchbar Popup
  const [open, setOpen] = useState(false);
  const [hoveredDropdown, setHoveredDropdown] = useState(null);
  const [guestCartCount, setGuestCartCount] = useState(0);
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const category = useSelector((state) => state.categories.categories);

  const handleDropdownEnter = (id) => setHoveredDropdown(id);
  const handleDropdownLeave = (id) => {
    if (hoveredDropdown === id) setHoveredDropdown(null);
  };

  const token = Cookies.get("token");
  const pathName = usePathname();
  const isActive = pathName === "/wishlist";
  const isActiveMyCart = pathName === "/my-cart";
  const dispatch = useDispatch();

  const { cartItems } = useSelector((state) => state.cart); // Get cart items from Redux
  const cartCount = cartItems?.cart?.items?.length || 0;

  const updateGuestCartCount = () => {
    const localCart = JSON.parse(localStorage.getItem("guestCart")) || [];
    // Count unique products instead of total quantity
    const totalProducts = localCart.length;

    setGuestCartCount(totalProducts);
  };

  useEffect(() => {
    dispatch(fetchCategories());
  }, [dispatch]);

  // Initial load
  useEffect(() => {
    if (!token) {
      updateGuestCartCount();
    } else {
      dispatch(fetchCartItems());
    }
  }, [dispatch, token]);

  // Listen for `localStorage` changes (when items are added/removed)
  useEffect(() => {
    const handleStorageChange = () => {
      updateGuestCartCount();
    };

    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);

  useEffect(() => {
    handleClose();
  }, [pathName]);

  return (
    <>
      {["xxl"].map((expand) => (
        <Navbar key={expand} expand={expand} className="py-4 navigation-sticky">
          <Container className="justify-content-between  align-items-center">
            <Navbar.Brand
              href="/"
              className="py-0 me-0 order-1 order-xxl-0 site-logo"
            >
              <Image
                src="/assets/images/navbar/logo/logo.svg"
                className="position-static h-auto w-auto"
                // fill
                width={50}
                height={50}
                alt="Logo-Image"
              />
            </Navbar.Brand>
            <Navbar.Toggle
              className="border-0 p-0 order-0 order-xxl-1 nav-toggle"
              aria-controls={`offcanvasNavbar-expand-${expand}`}
            >
              <BarIcon />
            </Navbar.Toggle>
            <Navbar.Offcanvas
              id={`offcanvasNavbar-expand-${expand}`}
              aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`}
              placement="start"
              className=" flex-grow-0"
            >
              <Offcanvas.Header className="border-bottom" closeButton>
                <Offcanvas.Title id={`offcanvasNavbarLabel-expand-${expand}`}>
                  <Image
                    src="/assets/images/navbar/logo/logo-shape.svg"
                    className="position-static"
                    height={50}
                    width={50}
                    alt="Logo Image"
                  />
                </Offcanvas.Title>
              </Offcanvas.Header>
              <Offcanvas.Body>
                <Nav className="align-items-xxl-center gap-3 gap-xxl-2 gap-xxl-0">
                  {/* <NavbarItem href="#" title="What’s New" /> */}
                  {category?.data?.map((cat) =>
                    cat.children?.length ? (
                      <div
                        key={cat.category_id}
                        onMouseEnter={() =>
                          handleDropdownEnter(cat.category_id)
                        }
                        onMouseLeave={() =>
                          handleDropdownLeave(cat.category_id)
                        }
                      >
                        <NavbarDropdown
                          id={`offcanvasNavbarDropdown-${cat.slug}`}
                          title={cat.category_name}
                          slug={cat.slug}
                          drodownItem={cat.children.map((child) => ({
                            name: child.category_name,
                            href: `/${child.slug}`,
                          }))}
                          show={hoveredDropdown === cat.category_id}
                        />
                      </div>
                    ) : (
                      <NavbarItem
                        key={cat.category_id}
                        href={`/${cat.slug}`}
                        title={cat.category_name}
                      />
                    )
                  )}
                  {/* <NavbarItem href="#" title="Collections" /> */}
                  <NavbarItem href="/about-us" title="About Us" />
                  <NavbarItem href="/contact-us" title="Contact Us" />
                  <NavbarItem href="/blog" title="Blogs" />
                </Nav>
              </Offcanvas.Body>
            </Navbar.Offcanvas>

            {pathName !== "/login" &&
              pathName !== "/register" &&
              pathName !== "/verification" && (
                <div className="order-2">
                  <div className="d-flex align-items-center nav-icons">
                    {/* <SerchIcon
                      className="cursor-pointer d-none d-sm-block"
                      onClick={() => setOpen(true)}
                    /> */}
                    <button
                      onClick={() => setOpen(true)}
                      className="bg-transparent border-0 p-0 me-2 cursor-pointer d-none d-sm-block"
                      aria-label="Open search"
                    >
                      <SerchIcon />
                    </button>
                    <SearchBarPopup show={open} onHide={() => setOpen(false)} />
                    <span className="d-none d-sm-block"></span>
                    <div className="d-flex align-items-center nav-iconlist">
                      <UserProfile />
                      <button
                        onClick={handleShow}
                        className="position-relative bg-transparent border-0 p-0"
                        aria-label="View your shopping cart"
                      >
                        {/* Added relative positioning */}
                        <TrollyIcon
                          className={`cursor-pointer ${
                            isActiveMyCart ? "isActive" : ""
                          }`}
                        />
                        {(token ? cartCount : guestCartCount) > 0 && (
                          <span
                            style={{
                              backgroundColor: "#00968F",
                              width: "24px",
                            }}
                            className="position-absolute top-0 start-100 translate-middle badge rounded-pill text-white"
                          >
                            {token ? cartCount : guestCartCount}
                          </span>
                        )}
                      </button>
                      {/* <Link href="/wishlist">
                      <HeartIcon
                        className={`cursor-pointer ${
                          isActive ? "isActive" : ""
                        }`}
                      />
                    </Link> */}
                    </div>
                  </div>
                </div>
              )}
          </Container>
        </Navbar>
      ))}
      <Offcanvas
        show={show}
        onHide={handleClose}
        placement="end"
        className="cart-canvas p-2 p-sm-3 p-md-4"
      >
        <div className="d-flex flex-column h-100 position-relative">
          <Offcanvas.Header className="justify-content-between p-2 p-sm-3">
            <Offcanvas.Title className="fw-semibold text-capitalize text-primary fs-lg ">
              Shopping Cart
            </Offcanvas.Title>
            <button
              className="p-0 border-0 bg-transparent close-btn "
              onClick={handleClose}
            >
              <CloseIcon />
            </button>
          </Offcanvas.Header>
          <Offcanvas.Body className="flex-grow-1 overflow-auto scrollbar-hidden">
            <ul className="list-unstyled cart-items-list">
              {cartdata?.map((item, i) => (
                <React.Fragment key={i}>
                  <li className="position-relative d-flex gap-4">
                    <div className="image-cover d-flex align-items-center justify-content-center">
                      <Image
                        src={item?.image}
                        alt="item-image"
                        width={96}
                        height={120}
                        className="object-fit-cover"
                      />
                    </div>
                    <div className="text-cover flex-grow-1">
                      <p className="category">{item?.type}</p>
                      <p className="text-primary fw-medium mt-2">
                        {item?.name}
                      </p>
                      <div className="d-flex gap-2 mt-2 details">
                        <p className="price fw-medium">
                          Size -{" "}
                          <span className="text-primary">{item?.size}</span>
                        </p>
                        <span className="separator">|</span>
                        <p className="price fw-medium">
                          Color -{" "}
                          <span className="text-primary">{item?.color}</span>
                        </p>
                      </div>
                      <div className="d-flex align-items-center justify-content-between mt-2 pt-1">
                        <div className="d-inline-flex align-items-center justify-content-center gap-2 rounded-1 number-incr-decr px-2">
                          <span
                            className="cursor-pointer"
                            onClick={
                              () => {}
                              // handleChangeQuantity(
                              //   cartItemId,
                              //   variantId,
                              //   item.quantity > stock
                              //     ? stock - 1
                              //     : item.quantity - 1,
                              //   productId,
                              //   stock
                              // )
                            }
                          >
                            <MinusIcon
                              size={10}
                              // color={item.quantity === 1 ? "#A7A7A7" : "#3C3C3C"}
                            />
                          </span>
                          <p className="d-flex align-items-center justify-content-center">
                            {/* {item.quantity > stock ? stock : item.quantity} */}
                            3
                          </p>
                          {/* here add this condition ${item.quantity >= stock ? "disabled" : ""} */}
                          <span
                            className={`cursor-pointer`}
                            onClick={() => {
                              // if (item.quantity >= stock) {
                              //   setShowErrorToast(true);
                              //   setMessage(
                              //     `Only ${stock} items available in stock.`
                              //   );
                              //   return;
                              // }
                              // handleChangeQuantity(
                              //   cartItemId,
                              //   variantId,
                              //   item.quantity + 1,
                              //   productId,
                              //   stock
                              // );
                            }}
                          >
                            <PlusIcon
                              size={10}
                              // color={item.quantity >= stock ? "#A7A7A7" : "#3C3C3C"}
                            />
                          </span>
                        </div>
                        <span className="item-price price">
                          &#8377;{item?.price}
                        </span>
                      </div>
                    </div>

                    <button
                      className="p-0 border-0 bg-transparent close-btn end-0 position-absolute top-0 mt-0 me-0 mt-sm-1 mt-md-2 me-sm-1 me-md-2"
                      onClick={handleClose}
                    >
                      <CloseIcon size={14} />
                    </button>
                  </li>
                  {i < cartdata?.length - 1 ? (
                    <hr className="border-top my-4" />
                  ) : null}
                </React.Fragment>
              ))}
            </ul>
          </Offcanvas.Body>
          <div className="offcanvas-footer p-3">
            <div className="d-flex justify-content-between text-align-center">
              <p className="text-primary">Sub Total: </p>
              <span className="fs-lg">&#8377;2499.00</span>
            </div>
            <CommonBtn
              className="  w-100 fw-normal outline-btn mt-4 "
              // onClick={() => router.push("/my-cart")}
              as={Link}
              href="/my-cart"
            >
              View Cart
            </CommonBtn>

            <CommonBtn
              variant="outline-primary"
              disabled={cartdata?.length === 0}
              className=" w-100 fw-normal  mt-3"
              // onClick={() => {}}
              as={Link}
              href="/checkout"
            >
              Checkout
            </CommonBtn>
          </div>
        </div>
      </Offcanvas>
    </>
  );
}
